import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step } from '@/composables/tour/stepHelpers';

registerTourPage('admin-my-courses', {
  key: 'admin-my-courses',
  label: 'My Courses',
  getSteps: () => [
    step({
      target: '#tour-my-courses-submit',
      title: 'Request a Course',
      content:
        'Submit a request to teach a course this term. The HOD or admin will review and approve, and approved allocations show up below.',
      placement: 'top',
    }),
    step({
      target: '#tour-my-courses-approved',
      title: 'Your Approved Courses',
      content:
        'The courses you\'re officially teaching this term. Click any course card to see the registered students and their status.',
      placement: 'top',
    }),
  ],
});

registerTourPage('admin-course-students', {
  key: 'admin-course-students',
  label: 'Course Students',
  getSteps: () => [
    step({
      target: '#tour-course-students-header',
      title: 'Course Roster',
      content:
        'Students who registered for this course in the current term. The header shows the course code, title, and unit count.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-course-students-grid',
      title: 'Registered Students',
      content:
        'Each card is one registration with the student\'s level, programme, and approval status. Use this to see who is officially on your list.',
      placement: 'top',
    }),
  ],
});
